import { ChangeEventHandler} from "react";

interface ToogleProps {
  name: string;
  checked?: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

const BcToogle = ({name, onChange, checked}: ToogleProps) => {

  return (
    <label className="bc-switch-container" tabIndex={0} htmlFor={name}>
      <input type="checkbox" id={name} onChange={onChange} checked={checked} />
      <div className="bc-switch">
        <div className="bc-switch-round"></div>
      </div>
    </label>
  );
};

export default BcToogle;


BcToogle.defaultProps = {
  name: 'default',
  onChange: (e: any) => console.log(e.target.checked)
}
